import React, { useState } from 'react';

const FAQSection = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="p-80px-tb faq-section bg-light">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center m-50px-b">
            <h2 className="section-title font-weight-bold m-20px-b">{data.pageTitle}</h2>
            <p className="lead text-muted">{data.pageSubtitle}</p>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            {data.items.map((item, index) => (
              <div key={index} className="faq-item m-20px-b">
                <div className="card shadow-sm">
                  <div
                    className="card-header bg-white p-25px cursor-pointer"
                    onClick={() => toggleFAQ(index)}
                  >
                    <h5 className="m-0 d-flex justify-content-between align-items-center">
                      <span className="font-weight-bold">
                        Q. {item.question}
                      </span>
                      <i className={`icofont-${activeIndex === index ? 'minus' : 'plus'} icofont-2x text-primary`}></i>
                    </h5>
                  </div>
                  {activeIndex === index && (
                    <div className="card-body p-30px bg-light">
                      <p className="m-0 text-muted">
                        <strong>A.</strong> {item.answer}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;